<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>パスワード再発行</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ユーザーコード</label>
              </div>
              <div class="col-9">
                {{user.userCode}}
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-9">
                {{user.userName}}
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>新しいパスワード</label>
              </div>
              <div class="col-9">
                <input type="password" maxlength="24" v-model="user.password" class="form-control" placeholder="パスワード" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
              </div>
                <div class="col-9">
                  <input name="isTemporaryPassword" id="isTemporaryPassword" type="checkbox" v-model="user.isTemporaryPassword">
                  <label for="isTemporaryPassword" class="checkbox">ユーザーにパスワードの変更を求める</label><br>
                </div>
            </div>
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">パスワードを再発行する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Reissue',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      message: '',
      id: '',
      user: {
        userCode: '',
        userName: '',
        password: '',
        isTemporaryPassword: false
      }
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  beforeMount() {
    this.id = this.$route.params.id
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var userId = this.id;
        axios.get("/api/user/" + userId, {
            headers: this.headers(accessToken)
        }).then(response => {
          this.user = {
            userCode: response.data.data.userCode,
            userName: response.data.data.userName,
            isTemporaryPassword: response.data.data.isTemporaryPassword
          }
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    modify() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var id = this.id;
          axios.put("/api/user/reissue/", {
              userId: id,
              password: this.user.password,
              isTemporaryPassword: this.user.isTemporaryPassword
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              var id = this.id;
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/modify/'+id))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      var id = this.$route.params.id;
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/modify/'+id))
    },
    reissue() {
    
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#modify_button {
  margin-top: 30px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>